import client, { setToken } from "./client";

export const login = async (email, password) => {
  const { data } = await client.post("/auth/login", { email, password });
  setToken(data.access_token, data.refresh_token);
  return data.user;
};

export const fetchMe = async () => (await client.get("/auth/me")).data;

export const logout = async () => {
  try {
    await client.post("/auth/logout");
  } finally {
    setToken(null);
  }
};

export const updateLanguage = (language) => client.put("/auth/me/language", { language });

export const changePassword = (current_password, new_password) =>
  client.put("/auth/me/password", { current_password, new_password });
